/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Ref,
  Ref$inboundSchema,
  Ref$Outbound,
  Ref$outboundSchema,
} from "./ref.js";

/**
 * The configuration of the animatic for a wind vane.
 */
export type AnimaticWindVaneConfig = {
  /**
   * A reference to a reading or setting.
   */
  vaneOrientationRef?: Ref | undefined;
  /**
   * A reference to a reading or setting.
   */
  windDirectionRef: Ref;
};

/** @internal */
export const AnimaticWindVaneConfig$inboundSchema: z.ZodType<
  AnimaticWindVaneConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  vane_orientation_ref: types.optional(Ref$inboundSchema),
  wind_direction_ref: Ref$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "vane_orientation_ref": "vaneOrientationRef",
    "wind_direction_ref": "windDirectionRef",
  });
});
/** @internal */
export type AnimaticWindVaneConfig$Outbound = {
  vane_orientation_ref?: Ref$Outbound | undefined;
  wind_direction_ref: Ref$Outbound;
};

/** @internal */
export const AnimaticWindVaneConfig$outboundSchema: z.ZodType<
  AnimaticWindVaneConfig$Outbound,
  z.ZodTypeDef,
  AnimaticWindVaneConfig
> = z.object({
  vaneOrientationRef: Ref$outboundSchema.optional(),
  windDirectionRef: Ref$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    vaneOrientationRef: "vane_orientation_ref",
    windDirectionRef: "wind_direction_ref",
  });
});

export function animaticWindVaneConfigToJSON(
  animaticWindVaneConfig: AnimaticWindVaneConfig,
): string {
  return JSON.stringify(
    AnimaticWindVaneConfig$outboundSchema.parse(animaticWindVaneConfig),
  );
}
export function animaticWindVaneConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticWindVaneConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticWindVaneConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticWindVaneConfig' from JSON`,
  );
}
